import { IWidgetInput } from './input/WidgetInput';
import { IProcedure } from '../Procedure';
import { IWidgetGraphic, WidgetGraphicType } from './graphic/WidgetGraphic';
import { IWidgetDynamic, WidgetDynamicType } from './dynamic/WidgetDynamic';
import { WidgetInputType } from './input/WidgetInputType';

export interface IWidget {
  id: number;
  order: number;
  procedureId: number;
  procedure: IProcedure;

  /** Gestisce se il Widget è annidato o reale (primo livello) */
  nested?: boolean;

  type: WidgetType;

  input?: IWidgetInput | null;
  graphic?: IWidgetGraphic | null;
  dynamic?: IWidgetDynamic | null;

  // Solo FrontEnd
  isPlaceholder?: boolean;
  justCreated?: boolean;
  subtype?: WidgetSubtype;
}

export enum WidgetType {
  Input = 'Input',
  Dynamic = 'Dynamic',
  Graphic = 'Graphic'
}

export type WidgetSubtype =
  | WidgetInputType
  | WidgetGraphicType
  | WidgetDynamicType;

export function getWidgetSubtype(widget: IWidget | null) {
  if (!widget) return undefined;

  switch (widget.type) {
    case WidgetType.Input:
      return widget.input!.type;
    case WidgetType.Graphic:
      return widget.graphic!.type;
    case WidgetType.Dynamic:
      return widget.dynamic!.type;
  }
}
